export const SERVICE_ADD = 'SERVICE_ADD';
export const SERVICE_EDIT = 'SERVICE_EDIT';
export const SERVICE_REMOVE = 'SERVICE_REMOVE';

// --- DATA MODEL --- //

export interface IServicesState
{
    myActiveServices: IServiceState[];
    allServices: {
        [id: string]: IServiceState[];
    };
}

export interface IServiceState
{
    id: string;
    userId: string;
    name: string;
    serviceType: string;
    properties: IProperty[];
    createdAt: string;
}

// --- ACTION MODEL --- //

interface AddServiceAction
{
    type: typeof SERVICE_ADD;
    serviceState: IServiceState;
}

interface EditServiceAction
{
    type: typeof SERVICE_EDIT;
    serviceState: IServiceState;
}

interface RemoveServiceAction
{
    type: typeof SERVICE_REMOVE;
    id: string;
    userId: string;
}

export type ServiceAction = AddServiceAction | EditServiceAction | RemoveServiceAction;

// ------------------- //